/**
 * Sample prose for "show the longest texts": the same sentence the backend uses
 * (voucher_design/catalog.py FILLER_SENTENCE), so canvas and PDF preview agree.
 */
const FILLER_SENTENCE =
  'Dieser Beispieltext zeigt, wie viel Platz ein langer Eintrag auf dem Gutschein braucht, damit nichts zu klein wird. ';

/** Up to `length` characters of sample prose, cut at a word boundary. */
export function fillerText(length: number): string {
  let text = '';
  while (text.length < length) text += FILLER_SENTENCE;
  let end = length;
  if (text.length > length && text[length] !== ' ') {
    const cut = text.lastIndexOf(' ', length);
    if (cut > 0) end = cut;
  }
  return text.slice(0, end).trimEnd();
}
